import { CalendarPageBlock } from "../../components/personal/CalendarPage/CalendarPageBlock"
import { TypicalPageStructure } from "../../components/reuse/TypicalPageStructure"

export const CalendarPage = () => {
    return(
        <>
        <TypicalPageStructure pageLabel={"Календарь аудитов"}>
            <CalendarPageBlock/>
        </TypicalPageStructure>
        </>
    )
}